/**
 * Created by Forev on 2017/6/12.
 */
export class CPCUser {

  public userName: string;
  public userId: string;
  public password: string;
  public isRemember: boolean;
  public email: string;
  public motto: string;
  public favorite: string;
  public roleOfUsers: string;
  public HomePageUrl: string;
  public mobile: string;
  public department: string; // 所属部门
  public EnablePwd: string; // 禁止更改密码
  public md5sn: string; // md5sn处理过得密码  非明文
  public sysuserid: number; //
  public currmrporgid: number; // 当前组织ID //切换组织的时候需要用到 非常量
  public entid: number; // 当前运营单元id  //切换组织的时候需要用到 非常量
  public entofloginusers: any; // 运营单元数据集合
  public invorgsearchofsyss: any; // 组织数据集合
  public UploadFileSizeLimit: any; // 上传最大允许值
  public roleofusers: any; // 用户的所有属性
  public limited: boolean; // 用户是否为限制用户 == 2 时 为限制用户

  constructor() {
    this.userName = '';
    this.userId = '';
    this.password = '';
    this.isRemember = false;
    this.HomePageUrl = '';
  }
}



// WEBPACK FOOTER //
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/src/app/login/CPCUser.ts